<template>
  <div class="operations">
    <button
      v-if="isEdit && data.dataSourceType === 'CONSUMER' && !data.deleteTag"
      @click="handleEdit"
    >
      <i class="icon_edit" />修改
    </button>
    <button
      v-if="isDelete && data.dataSourceType === 'CONSUMER' && !data.deleteTag"
      @click="handleDelete"
    >
      <i class="icon_delete" />删除
    </button>
    <button
      v-if="data.dataSourceType !== 'CONSUMER' && !data.deleteTag"
      @click="handleCorrigendum(data.dataId)"
    >
      <i class="icon_corrigendum" />勘误
    </button>
    <button @click="handleRecords(data.dataId)">
      <i class="icon_dataSource" />数据记录<RedDot v-if="data.redDotMark" />
    </button>
  </div>
</template>

<script>
import RedDot from "./RedDot.vue";
import { redDotMarkDeal } from "@/api/user";
export default {
  components: { RedDot },
  props: {
    data: {
      type: Object
    },
    isEdit: {
      type: Boolean,
      value: false
    },
    isDelete: {
      type: Boolean,
      value: false
    }
    // isCorrigendum: {
    //   type: Boolean,
    //   value: false
    // }
  },
  methods: {
    handleCorrigendum(id) {
      //   this.$router.push("corrigendum?id=" + id);
      let routeData = this.$router.resolve({
        path: "corrigendum",
        query: { id }
      });
      window.open(routeData.href, "_blank");
    },
    handleRecords(id) {
      redDotMarkDeal(id).then(res => {
        this.$emit("updateRedDotMark");
        let routeData = this.$router.resolve({
          path: "/personal/dataSource",
          query: { id }
        });
        window.open(routeData.href, "_blank");
      });
    },
    handleEdit() {
      this.$emit("handleEdit");
    },
    handleDelete() {
      this.$emit("handleDelete");
    }
  }
};
</script>

<style scoped lang="scss">
.operations {
  display: flex;
  justify-content: flex-end;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 50px;
  button {
    margin-left: 10px;
    outline: none;
    background: none;
    border: 0;
    // color: #3a61b1;
    // font-size: 14px;
    cursor: pointer;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #787878;
  }
  .redDot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    background: #ff3817;
    border: 2px solid #fff;
    position: relative;
    top: -5px;
  }
}
.icon_edit {
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url("../assets/icon_edit.png");
  background-size: cover;
  margin-right: 10px;
  position: relative;
  top: 3px;
}
.icon_delete {
  width: 15px;
  height: 16px;
  display: inline-block;
  background: url("../assets/icon_delete.png");
  background-size: cover;
  margin-right: 10px;
  position: relative;
  top: 3px;
}
.icon_corrigendum {
  width: 16px;
  height: 15px;
  display: inline-block;
  background: url("../assets/icon_corrigendum.png");
  background-size: cover;
  margin-right: 10px;
  position: relative;
  top: 3px;
}
.icon_dataSource {
  width: 15px;
  height: 15px;
  display: inline-block;
  background: url("../assets/icon_dataSource.png");
  background-size: cover;
  margin-right: 10px;
  position: relative;
  top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/OperationList.vue